/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Today_Stat_ExercisesInputs */

const en_us2_today_stat_exercises = /** @type {(inputs: Today_Stat_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`exercise`);
	return /** @type {LocalizedString} */ (`exercises`)
	
};

const pt_br2_today_stat_exercises = /** @type {(inputs: Today_Stat_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`exercício`);
	return /** @type {LocalizedString} */ (`exercícios`)
	
};

const es_419_today_stat_exercises = /** @type {(inputs: Today_Stat_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`ejercicio`);
	return /** @type {LocalizedString} */ (`ejercicios`)
	
};

const pt_pt2_today_stat_exercises = /** @type {(inputs: Today_Stat_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`exercício`);
	return /** @type {LocalizedString} */ (`exercícios`)
	
};

const fr_fr2_today_stat_exercises = /** @type {(inputs: Today_Stat_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`exercice`);
	return /** @type {LocalizedString} */ (`exercices`)
	
};

const de_de2_today_stat_exercises = /** @type {(inputs: Today_Stat_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Übung`);
	return /** @type {LocalizedString} */ (`Übungen`)
	
};

const it_it2_today_stat_exercises = /** @type {(inputs: Today_Stat_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`esercizio`);
	return /** @type {LocalizedString} */ (`esercizi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "exercise" |
* | * | "exercises" |
*
* @param {Today_Stat_ExercisesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_stat_exercises = /** @type {((inputs: Today_Stat_ExercisesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Stat_ExercisesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_stat_exercises(inputs)
	if (locale === "es-419") return es_419_today_stat_exercises(inputs)
	if (locale === "pt-PT") return pt_pt2_today_stat_exercises(inputs)
	if (locale === "fr-FR") return fr_fr2_today_stat_exercises(inputs)
	if (locale === "de-DE") return de_de2_today_stat_exercises(inputs)
	if (locale === "it-IT") return it_it2_today_stat_exercises(inputs)
	return en_us2_today_stat_exercises(inputs)
});
export { today_stat_exercises as "today.stat_exercises" }